import { createContext, useContext } from 'react'

export type RightPanelRequest = { key: string; id: number } | null

export type RightPanelValue = {
  expanded: boolean
  toggle: () => void
  openModule: (key: string) => void
  request: RightPanelRequest
  handledRequestId: number | null
  markRequestHandled: (id: number) => void
  setNotification: (key: string, count: number) => void
}

const noop = () => {}

// Without a provider (tests, a module shown outside the page) the panel reads as open.
export const defaultRightPanel: RightPanelValue = {
  expanded: true,
  toggle: noop,
  openModule: noop,
  request: null,
  handledRequestId: null,
  markRequestHandled: noop,
  setNotification: noop,
}

export const RightPanelContext = createContext<RightPanelValue>(defaultRightPanel)

export const RightPanelNotificationsContext = createContext<Record<string, number>>({})

export const useRightPanel = () => useContext(RightPanelContext)

export const useModuleNotificationCount = (moduleKey: string) =>
  useContext(RightPanelNotificationsContext)[moduleKey] ?? 0
